import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'era-lost-mode-confirmation-modal',
  templateUrl: './lost-mode-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, ReactiveFormsModule],
})
export class LostModeConfirmationModalComponent {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly fb = inject(UntypedFormBuilder);

  public readonly lostModeForm = this.fb.group({
    message: '',
    footnote: '',
  });

  public enableLostMode(): void {
    const message: string = this.lostModeForm?.get('message')?.value;
    const footnote: string = this.lostModeForm?.get('footnote')?.value;
    const result = { message, footnote };
    this.activeModal.close(result);
  }
}
